import EmptyList from "@/components/Common/EmptyList";
import ConnectionsListItem from "./ConnectionsListItem";
import ConnectionsListSearchPanel from "./ConnectionsListSearchPanel";
import ConnectionsAttemptsHistoryList from "./ConnectionsAttemptsHistoryList";

// @vue/component
export default {
  name: "ConnectionsList",

  components: {
    EmptyList,
    ConnectionsListItem,
    ConnectionsListSearchPanel,
    ConnectionsAttemptsHistoryList
  },
  props: {
    projectList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      currentPage: 1,
      isModalWithAttempHistoryVisible: false,
      connectionId: null,
      sortingDirection: 1,
      PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
      connectionsPerPage: 20,
      connectionUuid: "",
      onlyRecords: 0,
      connectionWithOpenSurvey: null,
    };
  },

  computed: {
    isLoading() {
      return this.$store.getters["global/pendingAsyncStoreActions"].includes([
        "connections/getList"
      ]);
    },
    connectionsList() {
      return this.$store.getters["connections/list"];
    },
    shoppingCart() {
      return this.$store.getters["record/recordsCart"];
    }
  },

  watch: {
    connectionsPerPage: {
      handler() {
        this.resetCurrentPage();
        this.$store.dispatch("connections/changeConnectionsPerPage", this.connectionsPerPage);
      }
    },
    sortingDirection: {
      handler() {
        this.resetCurrentPage();
        this.$store.dispatch("connections/changeSortingDirection", this.sortingDirection);
      }
    },
    onlyRecords: {
      handler() {
        this.resetCurrentPage();
        this.$store.dispatch("connections/filterList", { only_records: this.onlyRecords });
      }
    }
  },

  created() {
    this.$store.dispatch("connections/clearFilteringCriteria");
    this.$store.dispatch('campaign/getSurveyInputTypesList');
  },

  methods: {
    selectOnSight() {
      this.connectionsList.records.forEach(elementInTable => {
        let cartItem = this.shoppingCart.find(
          elementInStore => elementInTable._wh1_uuid === elementInStore._wh1_uuid
        );
        if (!cartItem && elementInTable._filename) {
          this.$store.commit("record/FILL_RECORDS_CART", elementInTable);
        }
      });
    },
    handleShowConnectionsAttempsHistory(connectionUuid) {
      this.isModalWithAttempHistoryVisible = true;
      this.connectionUuid = connectionUuid;
    },
    handleChangePage(page) {
      this.currentPage = page;
      this.$store.dispatch("connections/changePage", page);
    },
    resetCurrentPage() {
      this.currentPage = 1;
    }
  }
};
